import React from "react";
import "../ExploreSlider/ExploreSlider.css";
import "../PopularDeals/PopularDeals.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CarousalCard from "../../Components/CarousalCard/CarousalCard";

const RelatedDeals = (props) => {
  const { relatedDealsList } = props;

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 2,
    },
  };

  const renderAssignedProjects =relatedDealsList.map((eachitem, index) => (
    <CarousalCard key={index} eachitem={eachitem} />
  ));

  return (
    <div className="popular-deals_main_container">
      <div className=" mb-4">
        <p className="latestloc-text">
          <span className="userline-title">Related</span> Deals
        </p>
      </div>
      <Carousel
        showDots={false}
        swipeable={true}
        draggable={true}
        autoPlay={true}
        ssr={true}
        renderDotsOutside={true}
        arrows={true}
        // arrows={isActive ? true : false}
        dotListClass="carousel_dot"
        className="slide"
        responsive={responsive}
      >
        {renderAssignedProjects}
      </Carousel>
      {relatedDealsList.length === 0 ? (
        <p className="NoDataAvailable">No data available!</p>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RelatedDeals;
